import { INavData } from '@coreui/angular-pro';
import { UserRole } from '@core-interfaces/global';

export interface INavDataWithRoles extends INavData {
  roles?: UserRole[];
  children?: INavDataWithRoles[];
}

export const navItems: INavDataWithRoles[] = [
  // {
  //   name: 'Dashboard',
  //   url: '/dashboard',
  //   iconComponent: { name: 'cil-speedometer' },
  //   badge: {
  //     color: 'info',
  //     text: 'NEW'
  //   }
  // },
  {
    title: true,
    name: 'Administración de Poligonos',
    class: 'text-secondary',
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
  },
  {
    name: 'Municipalidades',
    url: '/municipality',
    iconComponent: { name: 'cil-home' },
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
    children: [
      {
        name: 'Lista',
        url: '/municipality',
        icon: 'nav-icon-bullet',
      },
      {
        name: 'Agregar Municipalidad',
        url: '/municipality/new',
        icon: 'nav-icon-bullet',
      },
    ],
  },

  {
    name: 'Comunas',
    url: '/commune',
    iconComponent: { name: 'cil-map' },
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
    children: [
      {
        name: 'Lista',
        url: '/commune',
        icon: 'nav-icon-bullet',
      },
      {
        name: 'Agregar Comuna (Poligono)',
        url: '/commune/new',
        icon: 'nav-icon-bullet',
      },
    ],
  },
  {
    name: 'Sectores',
    url: '/sector',
    iconComponent: { name: 'cil-location-pin' },
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
    children: [
      {
        name: 'Lista',
        url: '/sector',
        icon: 'nav-icon-bullet',
      },
      {
        name: 'Agregar Sector (Poligono)',
        url: '/sector/new',
        icon: 'nav-icon-bullet',
      },
    ],
  },
  {
    title: true,
    name: 'Puntos de Reciclaje',
    class: 'text-secondary',
  },
  {
    name: 'Tipos de Elementos',
    url: '/recycling-element-type',
    iconComponent: { name: 'cil-list' },
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
    children: [
      {
        name: 'Lista',
        url: '/recycling-element-type',
        icon: 'nav-icon-bullet',
      },
      {
        name: 'Nuevo Tipo',
        url: '/recycling-element-type/new',
        icon: 'nav-icon-bullet',
      },
    ],
  },
  {
    name: 'Puntos de Reciclaje',
    url: '/recycling-point',
    iconComponent: { name: 'cil-location-pin' },
    children: [
      {
        name: 'Lista',
        url: '/recycling-point',
        icon: 'nav-icon-bullet',
      },
      {
        name: 'Carga Masiva Excel',
        url: '/recycling-point/bulk-upload',
        icon: 'nav-icon-bullet',
      },
      {
        name: 'Nuevo Punto',
        url: '/recycling-point/new',
        icon: 'nav-icon-bullet',
      },
    ],
  },
  /*{
    title: true,
    name: 'Administración KDM',
    class: 'text-secondary'
  },
  {
    name: 'Comunas inscritas en la app',
    url: '/municipality',
    iconComponent: { name: 'cil-home' },
    children: [
      {
        name: 'Lista',
        url: '/municipality',
        icon: 'nav-icon-bullet'
      },
      {
        name: 'Inscribir Comuna',
        url: '/municipality/new',
        icon: 'nav-icon-bullet'
      }
    ]
  },*/

  /*{
    title: true,
    name: 'Administración de Horarios',
    class: 'text-secondary'
  },
  {
    name: 'Programaciones',
    url: '/schedule',
    iconComponent: { name: 'cil-calendar' },
    children: [
      {
        name: 'Lista',
        url: '/schedule',
        icon: 'nav-icon-bullet'
      },
      {
        name: 'Calendario',
        url: '/schedule/calendar',
        icon: 'nav-icon-bullet'
      },
      {
        name: 'Nueva Programación',
        url: '/schedule/new',
        icon: 'nav-icon-bullet'
      }
    ]
  },*/
  {
    title: true,
    name: 'Notificaciones',
    class: 'text-secondary',
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
  },
  {
    name: 'Campañas',
    url: '/campaign',
    iconComponent: { name: 'cil-bell' },
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
    children: [
      {
        name: 'Lista',
        url: '/campaign',
        icon: 'nav-icon-bullet',
      },
      {
        name: 'Nueva Campaña',
        url: '/campaign/new',
        icon: 'nav-icon-bullet',
      },
    ],
  },
  {
    title: true,
    name: 'Administración de Usuarios',
    class: 'text-secondary',
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
  },
  {
    name: 'Solicitudes',
    url: '/request',
    iconComponent: { name: 'cil-envelope-closed' },
    children: [
      {
        name: 'Gestión de Solicitudes',
        url: '/request',
        icon: 'nav-icon-bullet',
      },
    ],
  },
  {
    name: 'Usuarios',
    url: '/user',
    iconComponent: { name: 'cil-user' },
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
    children: [
      {
        name: 'Lista',
        url: '/user',
        icon: 'nav-icon-bullet',
      },
      /*{
        name: 'Crear Usuario',
        url: '/user/new',
        icon: 'nav-icon-bullet'
      },
      {
        name: 'Mi Perfil',
        url: '/user/profile',
        icon: 'nav-icon-bullet'
      },*/
    ],
  },
  {
    name: 'Usuarios Administradores',
    url: '/admin-user',
    iconComponent: { name: 'cil-user' },
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
    children: [
      {
        name: 'Lista',
        url: '/admin-user',
        icon: 'nav-icon-bullet',
      },
      {
        name: 'Crear Usuario',
        url: '/admin-user/new',
        icon: 'nav-icon-bullet',
      },
      /*{
        name: 'Mi Perfil',
        url: '/user/profile',
        icon: 'nav-icon-bullet'
      },*/
    ],
  },
  {
    title: true,
    name: 'Gestión de Contenido',
    class: 'text-secondary',
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
  },
  {
    name: 'Noticias',
    url: '/news',
    iconComponent: { name: 'cil-newspaper' },
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
    children: [
      {
        name: 'Lista',
        url: '/news',
        icon: 'nav-icon-bullet',
      },
      {
        name: 'Nueva Noticia',
        url: '/news/new',
        icon: 'nav-icon-bullet',
      },
    ],
  },
  {
    name: 'Mensajes Informativos',
    url: '/commune-informative-message',
    iconComponent: { name: 'cil-chat-bubble' },
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
  },
  {
    title: true,
    name: 'Configuración',
    class: 'text-secondary',
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
  },
  {
    name: 'Configuración Global',
    url: '/app-settings',
    iconComponent: { name: 'cil-settings' },
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
  },
  {
    name: 'Configuración de Camiones',
    url: '/truck-settings',
    iconComponent: { name: 'cil-truck' },
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
  },
  {
    name: 'Configuración visual',
    url: '/visual-settings',
    iconComponent: { name: 'cil-devices' },
    roles: [UserRole.Administrator, UserRole.SuperAdministrator],
  },
  // {
  //   name: 'Roles',
  //   url: '/role',
  //   iconComponent: { name: 'cil-people' },
  //   children: [
  //     {
  //       name: 'Lista',
  //       url: '/role',
  //       icon: 'nav-icon-bullet'
  //     },
  //     {
  //       name: 'Crear Rol',
  //       url: '/role/new',
  //       icon: 'nav-icon-bullet'
  //     }
  //   ]
  // },
  /*{
    title: true,
    name: 'Auditorias',
    class: 'text-secondary'
  },
  {
    name: 'Registros del Sistema',
    url: '/log',
    iconComponent: { name: 'cil-list' },
    children: [
      {
        name: 'Consultar Logs',
        url: '/log',
        icon: 'nav-icon-bullet'
      }
    ]
  },*/

  /*{
    title: true,
    name: 'Theme',
    class: 'text-secondary'
  },
  {
    name: 'Theme',
    url: '/theme',
    iconComponent: { name: 'cil-paint-bucket' },
    children: [
      {
        name: 'Colors',
        url: '/theme/colors',
        iconComponent: { name: 'cil-drop' }
      },
      {
        name: 'Typography',
        url: '/theme/typography',
        linkProps: { fragment: 'headings' },
        iconComponent: { name: 'cil-pencil' }
      },
      {
        name: 'Components',
        title: true,
        class: 'text-secondary'
      },
      {
        name: 'Base',
        url: '/base',
        iconComponent: { name: 'cil-puzzle' },
        children: [
          {
            name: 'Accordion',
            url: '/base/accordion',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Breadcrumbs',
            url: '/base/breadcrumbs',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Cards',
            url: '/base/cards',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Carousel',
            url: '/base/carousel',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Collapse',
            url: '/base/collapse',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'List Group',
            url: '/base/list-group',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Navs & Tabs',
            url: '/base/navs',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Pagination',
            url: '/base/pagination',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Placeholder',
            url: '/base/placeholder',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Popovers',
            url: '/base/popovers',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Progress',
            url: '/base/progress',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Spinners',
            url: '/base/spinners',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Tables',
            url: '/base/tables',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Tabs',
            url: '/base/tabs',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Tooltips',
            url: '/base/tooltips',
            icon: 'nav-icon-bullet'
          }
        ]
      },
      {
        name: 'Buttons',
        url: '/buttons',
        iconComponent: { name: 'cil-cursor' },
        children: [
          {
            name: 'Buttons',
            url: '/buttons/buttons',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Button groups',
            url: '/buttons/button-groups',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Dropdowns',
            url: '/buttons/dropdowns',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Loading Button',
            url: '/buttons/loading-buttons',
            icon: 'nav-icon-bullet',
            badge: {
              color: 'danger-gradient',
              text: 'PRO'
            }
          }
        ]
      },
      {
        name: 'Forms',
        url: '/forms',
        iconComponent: { name: 'cil-notes' },
        children: [
          {
            name: 'Form Control',
            url: '/forms/form-control',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Select',
            url: '/forms/select',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Multi Select',
            url: '/forms/multi-select',
            icon: 'nav-icon-bullet',
            badge: {
              color: 'danger-gradient',
              text: 'PRO'
            }
          },
          {
            name: 'Checks & Radios',
            url: '/forms/checks-radios',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Range',
            url: '/forms/range',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Input Group',
            url: '/forms/input-group',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Floating Labels',
            url: '/forms/floating-labels',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Date Picker',
            url: '/forms/date-picker',
            icon: 'nav-icon-bullet',
            badge: {
              color: 'danger-gradient',
              text: 'PRO'
            }
          },
          {
            name: 'Date Range Picker',
            url: '/forms/date-range-picker',
            icon: 'nav-icon-bullet',
            badge: {
              color: 'danger-gradient',
              text: 'PRO'
            }
          },
          {
            name: 'Layout',
            url: '/forms/layout',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Time Picker',
            url: '/forms/time-picker',
            icon: 'nav-icon-bullet',
            badge: {
              color: 'danger-gradient',
              text: 'PRO'
            }
          },
          {
            name: 'Validation',
            url: '/forms/validation',
            icon: 'nav-icon-bullet'
          }
        ]
      },
      {
        name: 'Icons',
        iconComponent: { name: 'cil-star' },
        url: '/icons',
        children: [
          {
            name: 'CoreUI Free',
            url: '/icons/coreui-icons',
            icon: 'nav-icon-bullet',
            badge: {
              color: 'success',
              text: 'FREE'
            }
          },
          {
            name: 'CoreUI Flags',
            url: '/icons/flags',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'CoreUI Brands',
            url: '/icons/brands',
            icon: 'nav-icon-bullet'
          }
        ]
      },
      {
        name: 'Notifications',
        url: '/notifications',
        iconComponent: { name: 'cil-bell' },
        children: [
          {
            name: 'Alerts',
            url: '/notifications/alerts',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Badges',
            url: '/notifications/badges',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Modal',
            url: '/notifications/modal',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Toast',
            url: '/notifications/toasts',
            icon: 'nav-icon-bullet'
          }
        ]
      },
      {
        name: 'Widgets',
        url: '/widgets',
        iconComponent: { name: 'cil-calculator' },
        badge: {
          color: 'info',
          text: 'NEW'
        }
      },
      {
        name: 'Smart Table',
        url: '/smart-table',
        iconComponent: { name: 'cil-grid' },
        badge: {
          color: 'danger-gradient',
          text: 'PRO'
        }
      },
      {
        title: true,
        name: 'Plugins',
        class: 'text-secondary'
      },
      {
        name: 'Calendar',
        iconComponent: { name: 'cil-calendar' },
        url: '/plugins/calendar'
      },
      {
        name: 'Charts',
        iconComponent: { name: 'cil-chart' },
        url: '/plugins/charts'
      },
      {
        name: 'Google Maps',
        iconComponent: { name: 'cil-map' },
        url: '/plugins/google-maps'
      },
      {
        title: true,
        name: 'Extras',
        class: 'text-secondary'
      },
      {
        name: 'Pages',
        url: '/login',
        iconComponent: { name: 'cil-star' },
        children: [
          {
            name: 'Login',
            url: '/login',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Register',
            url: '/register',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Error 404',
            url: '/404',
            icon: 'nav-icon-bullet'
          },
          {
            name: 'Error 500',
            url: '/500',
            icon: 'nav-icon-bullet'
          }
        ]
      },
      {
        name: 'Apps',
        url: '/apps',
        iconComponent: { name: 'cil-layers' },
        children: [
          {
            name: 'Invoicing',
            iconComponent: { name: 'cil-spreadsheet' },
            url: '/apps/invoicing',
            children: [
              {
                name: 'Invoice',
                url: '/apps/invoicing/invoice',
                icon: 'nav-icon-bullet',
                badge: {
                  color: 'danger-gradient',
                  text: 'PRO'
                }
              }
            ]
          },
          {
            name: 'Email',
            url: '/apps/email',
            iconComponent: { name: 'cil-envelope-open' },
            children: [
              {
                name: 'Inbox',
                url: '/apps/email/inbox',
                icon: 'nav-icon-bullet',
                badge: {
                  color: 'danger-gradient',
                  text: 'PRO'
                }
              },
              {
                name: 'Message',
                url: '/apps/email/message',
                icon: 'nav-icon-bullet',
                badge: {
                  color: 'danger-gradient',
                  text: 'PRO'
                }
              },
              {
                name: 'Compose',
                url: '/apps/email/compose',
                icon: 'nav-icon-bullet',
                badge: {
                  color: 'danger-gradient',
                  text: 'PRO'
                }
              }
            ]
          }
        ]
      },
      {
        title: true,
        name: 'Links',
        class: 'text-secondary'
      },
      {
        name: 'Docs',
        url: 'https://coreui.io/angular/docs/5.x/',
        iconComponent: { name: 'cil-description' },
        attributes: { target: '_blank' }
      }
    ]
  }*/
];

/**
 * Filters navigation items based on user role
 * @param items Navigation items to filter
 * @param userRole Current user's role
 * @returns Filtered navigation items
 */
export function filterNavByRole(items: INavDataWithRoles[], userRole: UserRole): INavData[] {
  return items
    .filter(item => {
      // If no roles specified, show to all users
      if (!item.roles || item.roles.length === 0) {
        return true;
      }
      // Check if user role is in allowed roles
      return item.roles.includes(userRole);
    })
    .map(item => {
      // Filter children recursively if they exist
      if (item.children && item.children.length > 0) {
        const filteredChildren = filterNavByRole(item.children, userRole);
        return {
          ...item,
          children: filteredChildren.length > 0 ? filteredChildren : undefined
        };
      }
      return item;
    })
    .filter(item => {
      // Remove parent items if all children were filtered out
      if (item.children !== undefined && item.children.length === 0) {
        return false;
      }
      return true;
    });
}

